import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { compose, getContext } from 'recompose';
import { SelectField } from 'redux-form-material-ui';
import { MenuItem, Divider } from 'material-ui';
import { Field, formValueSelector } from 'redux-form';
import { fetchTeamsBySportAndLeague } from 'dash-front/actions';
import { teamsKeyBySportAndTtId, getEntities } from 'dash-front/selectors/';
import { getFieldPath } from 'dash-front/campaign/components/helpers';

class TeamPicker extends React.PureComponent {
    componentDidMount() {
        const { sport, tournamentId, fetchTeams } = this.props;
        fetchTeams(sport, tournamentId);
    }

    componentWillReceiveProps({ sport, tournamentId }) {
        if (
            this.props.sport !== sport ||
            this.props.tournamentId !== tournamentId
        ) {
            this.props.fetchTeams(sport, tournamentId);
        }
    }

    renderOptions() {
        const { teamIds } = this.props;
        const { teams, value } = this.props;
        const ids = Array.isArray(teamIds) ? teamIds.slice() : [];
        if (
            value &&
            value !== '*' &&
            !ids.some(id => String(id) === String(value))
        ) {
            ids.push(value);
        }
        return ids.map(id => (
            <MenuItem
                key={id}
                primaryText={_.get(teams, `${id}.name`, `TeamId: ${id}`)}
                value={String(id)}
            />
        ));
    }

    render() {
        const { name } = this.props;
        const fieldProps = _.omit(
            this.props,
            Object.keys(TeamPicker.propTypes)
        );
        const options = this.renderOptions();
        return (
            <div>
                <Field
                    floatingLabelText={'Team'}
                    {...fieldProps}
                    name={name}
                    component={SelectField}
                >
                    <MenuItem value={'*'} primaryText={'Any'} />
                    {_.get(options, 'length') ? <Divider /> : null}
                    {options}
                </Field>
            </div>
        );
    }
}

const mapStateToProps = (
    state,
    { sport, tournamentId, name, _reduxForm: { form, sectionPrefix } }
) => ({
    value: formValueSelector(form)(state, getFieldPath(sectionPrefix, name)),
    teamIds: getEntities(state)[teamsKeyBySportAndTtId(sport, tournamentId)],
    teams: getEntities(state).teams
});

const mapDispatchToProps = dispatch => ({
    fetchTeams: (sportId, tournamentId) =>
        dispatch(fetchTeamsBySportAndLeague({ sportId, tournamentId }))
});

export default compose(
    getContext({
        _reduxForm: PropTypes.object
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(TeamPicker);

TeamPicker.propTypes = {
    name: PropTypes.string.isRequired,
    sport: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tournamentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    teamIds: PropTypes.array,
    teams: PropTypes.object,
    fetchTeams: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    _reduxForm: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/pickers/TeamPicker2.js
 **/